import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import { BaseProvider } from '../providers/base-provider';

@Injectable()
export class BusinessMessageProvider extends BaseProvider {
  	punchCardId: any = 0; 

	status: any = {
		SentThisMonth: 0,
		AvailableThisMonth: 0,
	};

	constructor(		
		public http: Http,	
		public globals: Globals,
		public storage: Storage,
		public httpHelper: HttpHelper) {
		super();
	}

	createMessage(params){
	    this.url = this.globals.dataUrl + 'business/message/detail/whiskey/' + this.globals.whiskeyId;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      params.data, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		    	
		    	
		        if(typeof params.cb == "function") params.cb(response);
		    });  
		})           
	}	

	getMessages(params){
		this.url = this.globals.dataUrl + 'business/message/detail' +

										  '/page/' + params.page +
										  '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		    		if(params.page==1){
		    			this.list = res.Data;
		    		}else{
		    			this.pushItems(res.Data);	
		    		}
		    		
		        	if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})  
	}

	getMessage(params){
		this.url = this.globals.dataUrl + 'business/message/detail/' + params.id;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );    
    	})  
	}

	getStatus(){
		this.url = this.globals.dataUrl + 'business/message/detail/status';

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		    		this.status = res.Data;
		    	}
		    );    
    	})  		
	}
}



// WEBPACK FOOTER //
// ./src/providers/business-message-handler.ts